<template>
  <font-awesome-icon
    icon="angle-double-down"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAngleDoubleDown } from '@fortawesome/free-solid-svg-icons'

library.add(faAngleDoubleDown)

export default {
  name: 'CoozzyAngleDoubleDownIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-text-grey;
  }
</style>
